import { forms } from './data';
import { CustomerHomeForm } from './type';

export const defaultValues: CustomerHomeForm = {
  // newsletter
  [forms.newsletter.email]: ''
};
